import type { AttributeMap, Op } from 'quill/core';

const walkTree = (value: unknown, visit: (value: unknown) => void) => {
  if (value == null) return;

  visit(value);

  if (Array.isArray(value)) {
    value.forEach((v) => walkTree(v, visit));
  } else if (typeof value === 'object') {
    Object.values(value).forEach((v) => walkTree(v, visit));
  }
};

const collectAttributes = (op: Op) => {
  const attributes: AttributeMap[] = [];
  // we need to deeply traverse delta ops to find all attributes
  // that are for example in nested ops in table-embed or code-embed
  walkTree(op, (value) => {
    if (
      value &&
      typeof value === 'object' &&
      'attributes' in value &&
      value.attributes !== null &&
      typeof value.attributes === 'object'
    ) {
      attributes.push(value.attributes as AttributeMap);
    }
  });

  return attributes;
};

const toStringArray = (value: unknown) => {
  return Array.isArray(value)
    ? value.filter((id) => typeof id === 'string')
    : [];
};

const collectThreadAndAnnotationIds = (ops: Op[]) => {
  const allThreadIds = new Set<string>();
  const allAnnotationIds = new Set<string>();

  ops.forEach((op) => {
    collectAttributes(op).forEach(({ comment, reaction, annotation }) => {
      toStringArray(comment).forEach((id) => allThreadIds.add(id));
      toStringArray(reaction).forEach((id) => allThreadIds.add(id));
      toStringArray(annotation).forEach((id) => allAnnotationIds.add(id));
    });
  });

  return {
    allThreadIds,
    allAnnotationIds,
  };
};

export default collectThreadAndAnnotationIds;
